exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".birth-date-container {\n  margin: 0; }\n  .birth-date-container .birth-date-label {\n    padding: 0 !important; }\n\n.birth-date-picker {\n  display: -ms-flexbox;\n  display: flex; }\n  .birth-date-picker .birth-date-month, .birth-date-picker .birth-date-day, .birth-date-picker .birth-date-year {\n    font-family: \"Open Sans\";\n    font-size: 12px;\n    font-weight: 300;\n    color: #a6a6a6; }\n  .birth-date-picker .birth-date-month {\n    margin: 10px 5px 10px 0px; }\n  .birth-date-picker .birth-date-day {\n    margin: 10px 5px 10px 5px; }\n  .birth-date-picker .birth-date-year {\n    margin: 10px 0px 10px 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /root/social-native/socialnative-web/node_modules/css-loader!/root/social-native/socialnative-web/node_modules/postcss-loader/src??ref--4-2!/root/social-native/socialnative-web/node_modules/sass-loader/lib/loader.js!../scss/form/component/birth_date_picker.scss
// module id = 2405
// module chunks = 69